<div class="df-datepicker-wrapper">
  <div class="form-floating">
    <input
      type="text"
      class="form-control"
      [id]="inputId"
      placeholder="__ / __ / ____"
      [class.is-invalid]="invalid"
      [disabled]="disabled"
      [value]="displayValue"
      bsDatepicker
      #dp="bsDatepicker"
      [bsValue]="dateValue"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [bsConfig]="bsConfig"
      (bsValueChange)="onDateChange($event)"
      (keydown)="onKeyDown($event)"
      (input)="onInputMask($event)"
      (blur)="onBlur()"
      container="body"
      placement="bottom"
      [outsideClick]="true"
      autocomplete="off"
      inputmode="numeric"
    />
    <label [for]="inputId">{{ label }}</label>
    <button
      *ngIf="!disabled"
      type="button"
      class="datepicker-toggle-btn"
      (click)="openCalendar()"
      aria-label="Open date picker"
    >
      <i class="bi bi-calendar3" aria-hidden="true"></i>
    </button>
  </div>
</div>
